import getQuickComposeViewState from './getQuickComposeViewState';
import { CharmSelectionType } from 'owa-calendar-helpers-types/lib/ComposeTypes';

export default function canSetCharmAutomatically(): boolean {
    const viewState = getQuickComposeViewState();
    let canSetCharm: boolean = false;

    if (viewState) {
        const selectionType = viewState.charmSelection;
        // We only set the charm automatically if it hasn't already been set by the user
        canSetCharm = selectionType != (CharmSelectionType.Manual || CharmSelectionType.Suggestion);
    }

    return canSetCharm;
}
